
import api from '@/services/api'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { Moderator, ModeratorRequest, ModeratorStatusBody } from '@/types/Moderator'
import { useRouter } from 'vue-router'
import { useToast } from 'primevue/usetoast'
import { useStore } from 'vuex'
import { UserRole } from '@/enums/UserRole'
import { useConfirm } from 'primevue/useconfirm'

export default defineComponent({
  props: ['id'],
  components: {},
  setup(props) {
    const router = useRouter()
    const toast = useToast()
    const confirm = useConfirm()
    const store = useStore()

    const moderator = ref<Moderator>({ } as Moderator)
    const isAdmin = computed<boolean>(() => store.state.userType === UserRole.Administrator)

    const statusBtnLabel = computed(() => {
      return moderator.value.activated ? 'Deactivate' : 'Activate'
    })

    onMounted(() => {
      fetchMod()
    })

    const fetchMod = (): void => {
      api.get(`admin/user/${props.id}`).then(res => {
        moderator.value = res?.data.data
      }).catch((err: any) => toast.add({ severity: 'error', summary: err.message, life: 3000}))
    }

    const handleSubmit = async () => {
      const newModerator: ModeratorRequest = { 
        externalId: moderator.value.externalId,
        email: moderator.value.email,
        name: moderator.value.name
      } as ModeratorRequest

      api.put('admin/user', JSON.stringify(newModerator))
        .then(() => router.push('/moderators'))
        .catch((err: any) => toast.add({ severity: 'error', summary: err.message, life: 3000}))
    }

    const setModStatus = () => {
      const body: ModeratorStatusBody = {
        externalId: moderator.value.externalId,
        status: !moderator.value.activated
      }
      api.post('admin/user/set-activate', JSON.stringify(body))
        .then(() => {
          fetchMod()
          toast.add({ severity: 'info', summary: 'Moderator status changed!', life: 3000})
        }).catch((err: any) => toast.add({ severity: 'error', summary: err.message, life: 3000}))
    }

    const resendInvitation = () => {
      api.post('admin/user/resendinvitation', JSON.stringify({ externalId: moderator.value.externalId }))
        .then(() => toast.add({ severity: 'info', summary: 'Invitation sent!', life: 3000 }))
        .catch((err: any) => toast.add({ severity: 'error', summary: err.message, life: 3000 }))
    }

    const resetPassword = () => {
      confirm.require({
        message: 'We will send you an email with link to set a new password. Do you want to continue?',
        header: 'Warning',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          api.post(
            `manager/identity/resetpassword`,
            JSON.stringify({ externalId: moderator.value.externalId }))
          .then(() => {
            toast.add({ severity: 'info', summary: 'Email has been sent.', life: 3000 })
          })
          .catch((err: any) => toast.add({ severity: 'error', summary: err.message, life: 3000}))
        }
      })
    }

    return { 
      moderator,
      statusBtnLabel,
      isAdmin,
      handleSubmit,
      setModStatus,
      resendInvitation,
      resetPassword
    }
  }
})
